import React from "react"
import DisabledLineItem from "./DisabledLineItem"

class RoomDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data){
      if (!this.props.data.identifier && this.props.data.room_type_name ) {
        if(this.props.data.room_type_status == "disabled" ) {
          return <DisabledLineItem {...this.props} roomDataType={true} />
        } else {
          return <div><span style={{fontStyle: 'italic'}}>{I18n.t('unassigned')} </span>{`(${this.props.data.room_type_name})`}</div>
        }
      } else if (this.props.data.room_type_name) {
        if(this.props.data.room_type_status == "disabled") {
          return <DisabledLineItem {...this.props} roomDataType={true} />
        } else {
          return <div>{this.props.data.identifier + ' (' + this.props.data.room_type_name + ')'}</div>
        }
      } else {
        return <div><p>{this.props.data.identifier} (<em>{I18n.t('none')}</em>)</p></div>
      }
    } else if (!this.props.row.identifier && this.props.row.room_type_name) {
      if(this.props.data.room_type_status == "disabled") {
        return <DisabledLineItem {...this.props} roomDataType={true} />
      } else {
        return <div><span style={{fontStyle: 'italic'}}>{I18n.t('unassigned')} </span>{`(${this.props.row.room_type_name})`}</div>
      }
    } else {
      return <span className="none">{I18n.t('none')}</span>
    }
  }
};

export default RoomDataType
